export default __webpack_public_path__ + "assets/overview-vid.mp4";